import React from "react";
import PageLayout from "../components/Layout/PageLayout";
import Contact from "../components/Sections/Contact";

export default function ContactPage() {
  return (
    <PageLayout
      path="/contact"
      title="Contact Finechek | Nairobi, Kenya"
      description="Get in touch with Finechek at Human House, Ngara West Road, Nairobi. Call 0722 822 595 or email info@finechek.com for product enquiries."
    >
      <Contact />
    </PageLayout>
  );
}
